/**
 * ProductStickyBar - sticky add-to-cart bar on product pages.
 * Custom element: <product-sticky-bar>
 *
 * Attributes (from $info):
 *   product          Object  -
 *   section-id       String  product-main
 *   default-variant  Object  -
 *
 * Refs:
 *   [data-ref="editButton"]  (optional)
 *   [data-ref="submitButton"]  (required)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import "./component-ProductForm.js";
import { ThemeComponent, setVariantUrlParam, scrollToElement } from "./theme.js";
import { queryString, axios } from "./vendor.js";
import "./component-QuantitySelector.js";
import "./component-ProductOptionPicker.js";
import "./component-ProductButtonOption.js";
import "./component-ProductDropdownOption.js";
import "./component-FakeDropdown.js";
import "./component-ProductStickyBar.js";
class ProductStickyBar extends ThemeComponent {
  constructor() {
    super(...arguments), this._selectedVariant = null, this.quantity = 1, this.siteFooter = document.querySelector(".site-footer"), this.scrollTargetElement = document.querySelector(".product-main .product-form__form"), this.productForm = null;
  }
  get selectedVariant() {
    return this._selectedVariant;
  }
  set selectedVariant(newVariant) {
    this._selectedVariant = newVariant, this.handleVariantChanged();
  }
  init() {
    this.productForm = document.querySelector(".product-details .product-form"), this.selectedVariant = this.defaultVariant, this.listenForVariantChange(), this.observeScroll(), this.listenForEditButtonClick(), this.listenForSubmitButtonClick();
  }
  handleVariantChanged() {
    var variantForUrl;
    this.classList.contains("product-form--card") || this.closest(".template-product") && setVariantUrlParam(((variantForUrl = this.selectedVariant) == null ? void 0 : variantForUrl.id) || null);
  }
  listenForVariantChange() {
    this.productForm && this.$subscribe(this.productForm.onSelectedPropertyChange, changedVariant => {
      var editButtonForMark;
      changedVariant != null && (this.selectedVariant = changedVariant, changedVariant.available ? (this.submitButton.classList.remove("product-sticky-bar__actions__submit--disabled"), this.submitButton.classList.remove("product-sticky-bar__actions__submit--unavailable")) : (this.submitButton.classList.remove("product-sticky-bar__actions__submit--disabled"), this.submitButton.classList.add("product-sticky-bar__actions__submit--unavailable")), (editButtonForMark = this.editButton) == null || editButtonForMark.classList.add("product-sticky-bar__actions__edit--selected"), this.render());
    });
  }
  observeScroll() {
    if (!this.scrollTargetElement) return;
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1
    };
    if ("IntersectionObserver" in window) {
      const scrollObserver = new IntersectionObserver((observerEntries, observerRef) => {
        const firstEntry = observerEntries[0];
        !firstEntry.isIntersecting && firstEntry.boundingClientRect.top < 0 ? this.classList.remove("product-sticky-bar--hidden") : this.classList.add("product-sticky-bar--hidden");
      }, observerOptions);
      this.scrollTargetElement && scrollObserver.observe(this.scrollTargetElement);
    }
  }
  listenForEditButtonClick() {
    this.editButton && this.$listen(this.editButton, "click", () => {
      scrollToElement(this.productForm);
    });
  }
  listenForSubmitButtonClick() {
    this.$listen(this.submitButton, "click", async () => {
      var formForAdd;
      this.submitButton.classList.add("product-sticky-bar__actions__submit--loading"), await ((formForAdd = this.productForm) == null ? void 0 : formForAdd.addToCart()), this.submitButton.classList.remove("product-sticky-bar__actions__submit--loading");
    });
  }
  async render() {
    if (!this.selectedVariant) return;
    const {
        url: pageUrl,
        query: query
      } = queryString.parseUrl(window.location.href, {
        decode: !1
      }),
      sectionUrl = queryString.stringifyUrl({
        url: pageUrl,
        query: {
          ...query,
          sections: `${this.sectionId}`,
          variant: this.selectedVariant.id
        }
      }, {
        arrayFormat: "none",
        encode: !1
      }),
      response = await axios.get(sectionUrl),
      parsedContainer = document.createElement("div");
    parsedContainer.innerHTML = response.data[`${this.sectionId}`];
    const newOptions = parsedContainer.querySelector(".product-sticky-bar__details__options"),
      existingOptions = this.querySelector(".product-sticky-bar__details__options");
    newOptions && existingOptions && (existingOptions.outerHTML = newOptions.outerHTML);
  }
}
setFunctionName(ProductStickyBar, "ProductStickyBar");
const propertyTypes = {
  Object,
  String
};
ProductStickyBar.prototype.$name = "ProductStickyBar";
ProductStickyBar.prototype.$info = JSON.parse('{"name":"ProductStickyBar","meta":{"isLegacy":false,"selector":"product-sticky-bar"},"props":[{"attr":"product","reflectAttr":false,"propertyKey":"product","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"Shopify.Liquid.Product"},{"attr":"section-id","default":"product-main","reflectAttr":false,"propertyKey":"sectionId","propertyType":"String","propertyTypeName":"String","propertyTsTypeName":"string"},{"attr":"default-variant","reflectAttr":false,"propertyKey":"defaultVariant","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"Shopify.Liquid.Variant"}],"refs":[{"selector":"[data-ref=\\"editButton\\"]","required":false,"propertyKey":"editButton","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLButtonElement"},{"selector":"[data-ref=\\"submitButton\\"]","required":true,"propertyKey":"submitButton","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLButtonElement"}]}');
ProductStickyBar.prototype.$info.component = ProductStickyBar;
for (const prop of ProductStickyBar.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Product/ProductStickyBar.ts", {
  ProductStickyBar: ProductStickyBar
}, void 0);